<template>
<SideBar />
  <div class="p-4 sm:ml-64 min-h-screen dark:bg-gray-900 text-white">
    <div class="container mx-auto p-4">
    <div class="mb-4 w-full max-w-2xl flex flex-col items-center">
      <video ref="video" class="w-full h-[60vh] rounded shadow border-4 border-blue-600 bg-black" autoplay playsinline></video>
      <button v-if="scanning" @click="stopScan" class="mt-2 px-4 py-2 bg-red-600 text-white rounded">Detener Escaneo</button>
      <button v-else @click="startScan" class="mt-2 px-4 py-2 bg-blue-600 text-white rounded">Reiniciar Escaneo</button>
    </div>
    <div v-if="barcode" class="mb-4">
      <p class="text-lg">Código escaneado: <span class="font-mono">{{ barcode }}</span></p>
      <button @click="fetchInfo" class="px-4 py-2 bg-green-600 text-white rounded">Buscar información</button>
    </div>
    <div v-if="info" class="mt-4 p-4 bg-white rounded shadow w-full max-w-md">
      <h2 class="font-bold mb-2">Información del producto</h2>
      <pre class="whitespace-pre-wrap">{{ info }}</pre>
    </div>
    <div v-if="error" class="mt-4 text-red-600">{{ error }}</div>
    </div>
  </div> 
  
</template>

<script>
import SideBar from "../components/NavBar.vue";

import { BrowserMultiFormatReader } from '@zxing/library';
// import axios from 'axios';
// import { API_URL } from '@/constants/constants';

export default {
  name: 'EscanerPage',
  data() {
    return {
      scanning: false,
      barcode: '',
      info: null,
      error: '',
      codeReader: null,
      videoInputDeviceId: null,
    };
  },
  components: {
    SideBar
  },
  methods: {
    async startScan() {
      this.error = '';
      this.barcode = '';
      this.info = null;
      this.scanning = true;
      if (this.codeReader) {
        this.codeReader.reset();
      }
      this.codeReader = new BrowserMultiFormatReader();
      try {
        const videoInputDevices = await this.codeReader.listVideoInputDevices();
        this.videoInputDeviceId = videoInputDevices[0]?.deviceId;
        this.codeReader.decodeFromVideoDevice(
          this.videoInputDeviceId,
          this.$refs.video,
          (result, err) => {
            if (result) {
              this.barcode = result.getText();
              this.stopScan();
            }
            if (err && err.name !== 'NotFoundException') {
              this.error = 'Error al escanear: ' + err;
            }
          }
        );
      } catch (e) {
        console.log('Error al acceder a la cámara:', e);
        this.error = 'No se pudo acceder a la cámara.';
        this.scanning = false;
      }
    },
    stopScan() {
      if (this.codeReader) {
        this.codeReader.reset();
      }
      this.scanning = false;
    },
    async fetchInfo() {
      this.error = '';
      this.info = null;
      try {
        // Cambia la ruta según tu API
        // const res = await axios.get(`${API_URL}/api/producto/barcode/${this.barcode}`);
        // this.info = res.data;
      } catch (e) {
        this.error = 'No se encontró información para este código.';
      }
    },
  },
  mounted() {
    this.startScan();
  },
  beforeUnmount() {
    if (this.codeReader) {
      this.codeReader.reset();
    }
  },
};
</script>

<style scoped>
video {
  max-width: 100%;
  min-height: 320px;
  max-height: 60vh;
  border: 4px solid #2563eb;
  background: #000;
}
</style>
